<div *ngIf="user ;  else loading" class="wrapper has-padding">
  <h1 class="bofa--heading is-4">Vendor registration</h1>
  <form [formGroup]="accountGroup" (ngSubmit)="onSubmit()">

    <div *ngIf="showError" class="global-red bottom-space">
      {{ user.errorMessage }}
    </div>

    <p class="global-red">All fields are required. Required fields are followed by <abbr title="required">*</abbr>.</p>

    <mat-form-field class="flex-width width-400" hideRequiredMarker>
      <mat-label><abbr title="required">* </abbr>Username</mat-label>
      <input matInput value="{{user.username}}" disabled>
      <mat-error>Please enter Username</mat-error>
    </mat-form-field>

    <div formGroupName="passwordGroup">
      <div class="is-taller">
        <mat-form-field class="divider zoom-padding-right width-200">
          <mat-label>Password</mat-label>
          <input matInput formControlName="password" (focus)="showHint($event)" (blur)="showHint($event)"
            [type]="hide ? 'password' : 'text'" maxlength="20" required autocomplete="off">
          <mat-hint>
            <div class="bofa--skiplink">
              <!-- Hidden divs are for screen readers -->
              <span>Rules:</span>
              <ul>
                <li>Minimum 8 characters long, Maximum of 20</li>
                <li>No special characters allowed: &, $, %, etc.</li>
                <li>At least one letter (a.k.a. alphabetic character)</li>
                <li>At least one number (a.k.a. numeric character)</li>
                <li>Cannot be your username</li>
              </ul>
            </div>
          </mat-hint>
          <mat-error>
            Please enter password
            <div class="bofa--skiplink">
              <ul>
                <li>Rules:</li>
                <li>Minimum 8 characters long, Maximum of 20</li>
                <li>No special characters allowed: &, $, %, etc.</li>
                <li>At least one letter (a.k.a. alphabetic character)</li>
                <li>At least one number (a.k.a. numeric character)</li>
                <li>Cannot be your username</li>
              </ul>
              <div *ngIf="!(password.value && (reenterPassword.value==password.value) && checkSpecialCharacters(password.value) &&
						checkAlphaCharacter(password.value) && checkNumeric(password.value) && (password.value != user.username))">
                Currently password does not match requirements
              </div>
            </div>
          </mat-error>
        </mat-form-field>

        <button type="button" class="bofa--button secondary outlined zoom-width flex-space" (click)="hide = !hide"
          [attr.aria-label]="'Show or Hide password'" [attr.aria-pressed]="hide">{{hide ? 'Show' : 'Hide'}}</button>
        <button type="button" class="bofa--button secondary" (click)="generatePassword()">Generate new strong
          password</button>
      </div>

      <div *ngIf="showPasswordHint"
        class="has-background cool-gray-5 has-padding flex-rules flex-text max-zoom min-font width-400">
        <span class="bottom-space">Rules</span>
        <ul class="list-reset">
          <li>
            <input formControlName="check1" type="checkbox"
              [checked]="password.value && (password.value.length >= 8 && password.value.length <= 20)" />Minimum 8 characters long, Maximum of 20
          </li>
          <li>
            <input formControlName="check2" type="checkbox"
              [checked]="password.value && checkSpecialCharacters(password.value)" />No special
            characters allowed: &, $, %, etc.
          </li>
          <li>
            <input formControlName="check3" type="checkbox"
              [checked]="password.value && checkAlphaCharacter(password.value)" />At least one letter
            (a.k.a. alphabetic character)
          </li>
          <li>
            <input formControlName="check4" type="checkbox"
              [checked]="password.value && checkNumeric(password.value)" />At least one number (a.k.a.
            numeric character)
          </li>
          <li>
            <input formControlName="check5" type="checkbox"
              [checked]="password.value && (password.value != user.username)" />Cannot be your username
          </li>
        </ul>
      </div>

      <div class="bottom-space padding-top">
        <mat-form-field class="width-200">
          <mat-label>Re-enter password</mat-label>
          <input matInput formControlName="reenterPassword" (focus)="showHintTwo($event)" (blur)="showHintTwo($event)"
            type="password" maxlength="20" required>
          <mat-hint>
            <div class="bofa--skiplink">
              Rules: must match previously entered password
            </div>
          </mat-hint>
          <mat-error *ngIf="reenterPassword.hasError('required') || reenterPassword.hasError('noMatch') ">
            Please re-enter password
            <div class="bofa--skiplink">
              Rules: must match previously entered password.
              <div *ngIf="!(password.value && (reenterPassword.value==password.value))">
                Currently passwords do not match
              </div>
            </div>
          </mat-error>
        </mat-form-field>
      </div>

      <div *ngIf="showReEnterPasswordHint"
        class="flex-rules flex-text has-background cool-gray-5 has-padding max-zoom min-font width-400">
        <span class="bottom-space">Rules</span>
        <ul class="list-reset">
          <li>
            <input type="checkbox" formControlName="check6"
              [checked]="password.value && (reenterPassword.value==password.value)" />Must match
            previously entered password
          </li>
        </ul>
      </div>
    </div>

    <div class="max-width width-735">
      <h2 class="bofa--heading is-6 padding-top">Select and answer five challenge questions</h2>
      <p class="has-no-padding small-font">If you forget your password, you will be asked to provide
        the answers to all five challenge questions before you are able to reset your password.</p>

      <div class="bofa--alert has-background cool-gray-5 has-padding is-stacked width-650">
        <ul class="has-no-padding has-no-margin list-sec">
          <li><span class="padd-10"> <img alt="information" src="assets/bofa_icon_info.svg"
                class="img-size"></span>Different questions. Different answers</li>
          <li class="padd-40">Note: You cannot select the same question twice or provide the same answer for
            different questions</li>
        </ul>
      </div>

      <div formGroupName='securityQuestions'>
        <mat-form-field class="secure-questions zoom-questions zoom-questions-width">
          <mat-label>Question 1</mat-label>
          <mat-select formControlName="question1" required>
            <mat-option>Select</mat-option>
            <mat-option *ngFor="let question of user.questionLookup | keyvalue : valueAscOrder" [value]="question">
              {{question.value}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="question1.hasError('required') || question1.hasError('duplicate') ">Please select
            Question 1 and ensure you have not selected a duplicate question</mat-error>
        </mat-form-field>

        <mat-form-field class="question-space secure-questions zoom-questions-width">
          <mat-label>Answer to question 1</mat-label>
          <input matInput type="password" formControlName="answer1" required autocomplete="off">
          <mat-error *ngIf="answer1.hasError('required') || answer1.hasError('duplicate')">Please enter answer 1 and
            ensure you have not
            duplicated an answer from a previous question</mat-error>
        </mat-form-field>

        <mat-form-field class="secure-questions zoom-questions zoom-questions-width">
          <mat-label>Question 2</mat-label>
          <mat-select formControlName="question2" required>
            <mat-option>Select</mat-option>
            <mat-option *ngFor="let question of user.questionLookup | keyvalue : valueAscOrder" [value]="question">
              {{question.value}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="question2.hasError('required') || question2.hasError('duplicate') ">Please select
            Question 2 and ensure you have not selected a duplicate question</mat-error>
        </mat-form-field>

        <mat-form-field class="question-space secure-questions zoom-questions-width">
          <mat-label>Answer to question 2</mat-label>
          <input matInput type="password" formControlName="answer2" required autocomplete="off">
          <mat-error *ngIf="answer2.hasError('required') || answer2.hasError('duplicate')">Please enter answer
            2 and ensure you have not duplicated an answer from a previous question</mat-error>
        </mat-form-field>

        <mat-form-field class="secure-questions zoom-questions zoom-questions-width">
          <mat-label>Question 3</mat-label>
          <mat-select formControlName="question3" required>
            <mat-option>Select</mat-option>
            <mat-option *ngFor="let question of user.questionLookup | keyvalue  : valueAscOrder" [value]="question">
              {{question.value}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="question3.hasError('required') || question3.hasError('duplicate')">Please
            select Question 3 and ensure you have not selected a duplicate question</mat-error>
        </mat-form-field>

        <mat-form-field class="question-space secure-questions zoom-questions-width">
          <mat-label>Answer to question 3</mat-label>
          <input matInput type="password" formControlName="answer3" required autocomplete="off">
          <mat-error *ngIf="answer3.hasError('required') || answer3.hasError('duplicate')">Please enter answer
            3 and ensure you have not duplicated an answer from a previous question</mat-error>
        </mat-form-field>

        <mat-form-field class="secure-questions zoom-questions zoom-questions-width">
          <mat-label>Question 4</mat-label>
          <mat-select formControlName="question4" required>
            <mat-option>Select</mat-option>
            <mat-option *ngFor="let question of user.questionLookup | keyvalue : valueAscOrder" [value]="question">
              {{question.value}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="question4.hasError('required') || question4.hasError('duplicate')">Please select
            Question 4 and ensure you have not selected a duplicate question</mat-error>
        </mat-form-field>

        <mat-form-field class="question-space secure-questions zoom-questions-width">
          <mat-label>Answer to question 4</mat-label>
          <input matInput type="password" formControlName="answer4" required autocomplete="off">
          <mat-error *ngIf="answer4.hasError('required') || answer4.hasError('duplicate')">Please enter answer
            4 and ensure you have not duplicated an answer from a previous question</mat-error>
        </mat-form-field>

        <mat-form-field class="secure-questions zoom-questions zoom-questions-width">
          <mat-label>Question 5</mat-label>
          <mat-select formControlName="question5" required>
            <mat-option>Select</mat-option>
            <mat-option *ngFor="let question of user.questionLookup | keyvalue : valueAscOrder" [value]="question">
              {{question.value}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="question5.hasError('required') || question5.hasError('duplicate')">Please select
            Question 5 and ensure you have not selected a duplicate question</mat-error>
        </mat-form-field>

        <mat-form-field class="question-space secure-questions zoom-questions-width">
          <mat-label>Answer to question 5</mat-label>
          <input matInput type="password" formControlName="answer5" required autocomplete="off">
          <mat-error *ngIf="answer5.hasError('required') || answer5.hasError('duplicate')">Please enter answer
            5 and ensure you have not duplicated an answer from a previous question</mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="bofa--action_bar is-taller mobile-flex">
      <button (submit)="onSubmit()" [disabled]="!accountGroup.valid" class="bofa--button primary large">Create my
        profile</button>
      <button type="button" class="bofa--button primary outlined" (click)="accountGroup.reset()">Clear all
        fields</button>
    </div>
    <div class="bofa--skiplink" tabindex="0" *ngIf="!accountGroup.valid" (focus)="invalidAlert()" (blur)="clearAlert()">
      <span aria-label="Form is not complete, create my profile button disabled" aria-live="polite" role="status"
        *ngIf="readMessage">Form is not complete, create my profile button disabled</span>
    </div>
  </form>
</div>

<ng-template #loading>
  <p>Loading Applicant User...</p>
</ng-template>